import { render, staticRenderFns } from "./PriceTable.vue?vue&type=template&id=8535a1f0&"
import script from "./PriceTable.vue?vue&type=script&lang=js&"
export * from "./PriceTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports